import AppDispatcher from '../AppDispatcher';

const QuoteFeedSymbolsActions = {
  set: (items) => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_FEED_SYMBOLS.SET,
      items: items
    });
  },
  update: () => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_FEED_SYMBOLS.UPDATE
    });
  }
};

export default QuoteFeedSymbolsActions;



// WEBPACK FOOTER //
// ./src/js/Actions/QuoteFeedSymbolsActions.js